import { vuex_subscribe_module, vuex_store_config } from '@/vuex'
import { load_state_from_local_storage } from '@/resources'

const vuex_config_object = {
  location: {
    label: '',
    latitude: '',
    longitude: '',
    match_level: '',
  },
  checkin: '',
  checkout: '',
  hotels: [],
  selected_hotel: {},
  hotel_details: [],
  current_search: '',
  rooms_selection: {
    model_products: [],
    product_quantities: {}
  },
  selected_solution: {},
  resume: {},  // recap dei prezzi
  last_search: '',
  trigger_search: false,

  // V4 filters
  sorters: [],
  filters: [],
  types: [],
  filter_availability: false,
  filter_cancellation_type: false,
  filter_accommodation_types: [],
  filter_price: {
    minimum: 0,
    maximum: 0,
  },
  filter_meal_plan: '',
  filter_rating: {
    minimum_review_score: [],
    stars: [],
  },
  filter_travel_proud: false,
  filter_accommodation_facilities: [],
  filter_room_facilities: [],
  filter_poi: {
    ext_id: null,
  },

  // V4 sorting
  sort: {
    by: '',
    direction: '',
  },
}

export const serialized_vuex_config_object = JSON.stringify(vuex_config_object)

const state_config = vuex_store_config(vuex_config_object)

let name = 'livebkv3',
  state = state_config.state,
  module = {
    namespaced: true,
    state: load_state_from_local_storage(name, state_config.state),
    mutations: {
      ...state_config.mutations,

      // aggiunge/aggiorna i prodotti nell'accommodation
      update_accommodation_products(state, products) {
        state.selected_solution.accommodation = {
          ...state.selected_solution.accommodation,
          products
        }
      },

      // setta il valore di multiroom_assignment
      set_multiroom_assignment(state, payload) {
        state.selected_solution.accommodation.multiroom_assignment = payload;
      },

      // aggiorna rooms_selection
      update_rooms_selection(state, payload) {
        state.rooms_selection = {
          ...state.rooms_selection,
          ...payload
        }
      },
      // aggiorna selected_solution
      update_selected_solution(state, payload) {
        state.selected_solution = {
          ...state.selected_solution,
          ...payload
        }
      }
    },
    getters: state_config.getters,
    actions: state_config.actions,
    get_local_storage_submodule() {
      // dichiaro le chiavi che verranno scritte nel local storage
      return {
        location: state_config.state.location,
        checkin: state_config.state.checkin,
        checkout: state_config.state.checkout,
        last_search: state_config.state.last_search,
        current_search: state_config.state.current_search,
        selected_hotel: state_config.state.selected_hotel,
        hotel_details: state_config.state.hotel_details,
        selected_solution: {},
        resume: {},

        // V4 filter
        sorters: state_config.state.sorters,
        filters: state_config.state.filters,
        types: state_config.state.types,
        filter_availability: state_config.state.filter_availability,
        filter_cancellation_type: state_config.state.filter_cancellation_type,
        filter_stars: state_config.state.filter_stars,
        filter_amenities: state_config.state.filter_amenities,
        filter_accommodation_types: state_config.state.filter_accommodation_types,
        filter_price: state_config.state.filter_price,
        filter_meal_plan: state_config.state.filter_meal_plan,
        filter_rating: state_config.state.filter_rating,
        filter_travel_proud: state_config.state.filter_travel_proud,
        filter_accommodation_facilities: state_config.state.filter_accommodation_facilities,
        filter_room_facilities: state_config.state.filter_room_facilities,
        //filter_poi: state_config.state.filter_poi,

        // V4 sort
        sort: state_config.state.sort,
      }
    },
  }

export function register_state_module(prototype) {
  if (prototype.$submodules == undefined) prototype.$submodules = {}
  prototype.$submodules[name] = {
    get_local_storage_submodule: module.get_local_storage_submodule()
  }
  vuex_subscribe_module(name, state, module)
}